import { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Button = ({
  label,
  animate,
  onClick,
  disabled,
  className,
  children,
  showSkeleton,
  ...props
}) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={classNames('btn', className, {
      'animate-container': animate,
      skeleton: showSkeleton,
    })}
    {...props}
  >
    {label}
    {children}
  </button>
);

Button.propTypes = {
  animate: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  className: PropTypes.string,
  showSkeleton: PropTypes.bool,
  label: PropTypes.string.isRequired,
};

export default memo(Button);
